module.exports = __webpack_public_path__ + "img/shopping-cart.589137db.svg";